/* c8 ignore start */
import { defineVueComponentAEM } from '@dh-io-owpi/shared/src/aem/vue';
import { createI18n } from '@dh-io-owpi/shared/src/plugins/i18n';
import App from './App.vue';

defineVueComponentAEM(App, import.meta.env.APP_NAME, [createI18n()]);
